import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Widget } from "smart-widget-previewer";
import axios from "axios";
import LoadingDots from "../Components/LoadingDots";

export default function Main() {
  const [widgets, setWidgets] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const getWidget = async () => {
      try {
        setIsLoading(true);
        const data = await axios.post("/");
        const widgetData = data.data;
        setWidgets(widgetData);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
        setIsLoading(false);
      }
    };
    getWidget();
  }, []);

  return (
    <div className="fit-container fx-centered fx-wrap">
      <div className="fit-container fx-centered box-pad-v">
        <h2>Smart widget templates</h2>
      </div>
      {isLoading && (
        <div className="fit-container fx-centered" style={{ height: "50vh" }}>
          <LoadingDots />
        </div>
      )}
      <div className="masonary box-pad-h" style={{ width: "min(100%,1400px)" }}>
        {widgets.map((widget, index) => {
          return (
            <Link
              key={index}
              style={{ width: "30%" }}
              className="pointer"
              to={widget.path}
            >
              <div
                className="fit-container sc-s-18 box-pad-h-m box-pad-v-m box-marg-s"
                style={{ pointerEvents: "none" }}
                onClick={null}
              >
                <h3 className="c1-c box-marg-s">{widget.title}</h3>
                <img src={widget.thumbnail} className="fit-container sc-s-18" />
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );

  /* Profile */
  // return (
  //   <div
  //     style={{
  //       width: "800px",
  //       minHeight: "450px",
  //       backgroundColor: "white",
  //     }}
  //   >
  //     <div
  //       style={{
  //         width: "100%",
  //         minHeight: "450px",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "flex-start",
  //         position: "relative",
  //         overflow: "hidden",
  //       }}
  //     >
  //       <div
  //         style={{
  //           position: "absolute",
  //           left: "50%",
  //           top: "50%",
  //           transform: "translate(-50%, -50%)",
  //           width: "120%",
  //           height: "120%",
  //           filter: "blur(6px)",
  //           backgroundSize: "cover",
  //           overflow: "hidden",
  //           backgroundPosition: "center",
  //           backgroundImage: `url(https://image.nostr.build/29572d4118c1b1e92a27a853e741bd8c1505f981f94262fd96e2d6586d72f7aa.png)`,
  //           zIndex: 0,
  //         }}
  //       ></div>
  //       <div
  //         style={{
  //           position: "absolute",
  //           left: 0,
  //           top: 0,
  //           width: "100%",
  //           height: "100%",
  //           backgroundColor: "rgba(0,0,0,.8)",
  //           zIndex: 1,
  //         }}
  //       ></div>
  //       <div
  //         style={{
  //           width: "100%",
  //           minHeight: "450px",
  //           position: "relative",
  //           zIndex: 2,
  //           display: "flex",
  //           justifyContent: "flex-start",
  //           gap: "20px",
  //           alignItems: "center",
  //           padding: "32px",
  //         }}
  //       >
  //         <div
  //           style={{
  //             minWidth: "200px",
  //             minHeight: "200px",
  //             borderRadius: "10px",
  //             overflow: "hidden",
  //             backgroundSize: "cover",
  //             backgroundPosition: "center",
  //             backgroundImage: `url(https://image.nostr.build/89ad0e9a72ff60b6c8c7dc71bb92800598c56d09cad44a4ff6b700479104811f.jpg)`,
  //           }}
  //         ></div>
  //         <div style={{ display: "flex", flexDirection: "column" }}>
  //           <h2 style={{ fontSize: "44px" }}>Alpha romeo</h2>
  //           <div style={{ height: "8px" }}></div>
  //           <p
  //             style={{
  //               fontSize: "20px",
  //               display: "-webkit-box",
  //               WebkitLineClamp: 10,
  //               WebkitBoxOrient: "vertical",
  //               overflow: "hidden",
  //             }}
  //           >
  //             Lorem, ipsum dolor sit amet consectetur adipisicing elit. Culpa
  //             iure earum nemo hic officiis sunt eum porro necessitatibus
  //             consequuntur aspernatur minus ipsa quasi aliquam repellat
  //             assumenda cumque quaerat, dolorum commodi.
  //           </p>

  //           <div style={{ height: "8px" }}></div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "flex-start",
  //               alignContent: "flex-start",
  //               gap: " 24px",
  //             }}
  //           >
  //             <p style={{ color: "#aaaaaa", fontSize: "20px" }}>NIP-05</p>
  //             <p style={{ fontSize: "20px" }}>moos@getalby.com</p>
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "flex-start",
  //               alignContent: "flex-start",
  //               gap: " 24px",
  //             }}
  //           >
  //             <p style={{ color: "#aaaaaa", fontSize: "20px" }}>LUD-16</p>
  //             <p style={{ fontSize: "20px" }}>moos@getalby.com</p>
  //           </div>

  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "flex-start",
  //               alignContent: "flex-start",
  //               gap: " 24px",
  //             }}
  //           >
  //             <p style={{ color: "#aaaaaa", fontSize: "20px" }}>Website</p>
  //             <p style={{ fontSize: "20px" }}>moos@getalby.com</p>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

  /* Stats */
  //  return (
  //   <div
  //     style={{
  //       width: "800px",
  //       minHeight: "800px",
  //       backgroundColor: "#171718",
  //     }}
  //   >
  //     <div
  //       style={{
  //         width: "100%",
  //         minHeight: "800px",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "flex-start",
  //         position: "relative",
  //         overflow: "hidden",
  //       }}
  //     >
  //       <div
  //         style={{
  //           width: "100%",
  //           minHeight: "800px",
  //           position: "relative",
  //           zIndex: 2,
  //           display: "flex",
  //           justifyContent: "flex-start",
  //           flexDirection: "column",
  //           gap: "20px",
  //           alignItems: "center",
  //           padding: "32px",
  //         }}
  //       >

  //         <div
  //           style={{
  //             minWidth: "200px",
  //             minHeight: "200px",
  //             borderRadius: "10px",
  //             overflow: "hidden",
  //             backgroundSize: "cover",
  //             backgroundPosition: "center",
  //             backgroundImage: `url(https://image.nostr.build/89ad0e9a72ff60b6c8c7dc71bb92800598c56d09cad44a4ff6b700479104811f.jpg)`,
  //           }}
  //         ></div>
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             flexDirection: "column",
  //           }}
  //         >
  //           <h2 style={{ fontSize: "38px" }}>Alpha romeo</h2>
  //           {/* <p style={{ fontSize: "24px", color: "#999999" }}>@Alpha romeo</p> */}
  //         </div>

  //         <hr style={{ width: "50%" }} />
  //         <p style={{ fontSize: "24px", color: "#999999" }}>User statistics</p>
  //         <hr style={{ width: "50%" }} />
  //         <div style={{ height: "16px" }}></div>
  //         <div
  //           style={{
  //             width: "100%",
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             gap: "76px",
  //           }}
  //         >
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center",
  //               alignItems: "center",
  //               flexDirection: "column",
  //             }}
  //           >
  //             <h1 style={{ fontSize: "64px" }}>301</h1>
  //             <p style={{ fontSize: "24px", color: "#999999" }}>Notes</p>
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center",
  //               alignItems: "center",
  //               flexDirection: "column",
  //             }}
  //           >
  //             <h1 style={{ fontSize: "64px" }}>301</h1>
  //             <p style={{ fontSize: "24px", color: "#999999" }}>Reactions</p>
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center",
  //               alignItems: "center",
  //               flexDirection: "column",
  //             }}
  //           >
  //             <h1 style={{ fontSize: "64px" }}>301</h1>
  //             <p style={{ fontSize: "24px", color: "#999999" }}>Long form </p>
  //           </div>
  //         </div>
  //         <div style={{ height: "26px" }}></div>
  //         <div
  //           style={{
  //             width: "100%",
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             gap: "76px",
  //           }}
  //         >
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center",
  //               alignItems: "center",
  //               flexDirection: "column",
  //             }}
  //           >
  //             <h1 style={{ fontSize: "64px" }}>301</h1>
  //             <p style={{ fontSize: "24px", color: "#999999" }}>Zap sent</p>
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center",
  //               alignItems: "center",
  //               flexDirection: "column",
  //             }}
  //           >
  //             <h1 style={{ fontSize: "64px" }}>301</h1>
  //             <p style={{ fontSize: "24px", color: "#999999" }}>Followers</p>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

  /* Quote */
  // return (
  //   <div
  //     style={{
  //       width: "800px",
  //       minHeight: "800px",
  //       backgroundColor: "#ee7700",
  //       padding: "5rem",

  //       display: "flex",
  //       justifyContent: "center",
  //       alignItems: "stretch",
  //     }}
  //   >
  //     <div
  //       style={{
  //         width: "100%",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         position: "relative",
  //         padding: "6rem 0 0",
  //         backgroundColor: "white",
  //         borderRadius: "10px",
  //       }}
  //     >
  //       <div
  //         style={{
  //           minWidth: "150px",
  //           minHeight: "150px",
  //           borderRadius: "50%",
  //           outline: "10px solid #ee7700",
  //           backgroundSize: "cover",
  //           backgroundPosition: "center",
  //           backgroundImage: `url(https://image.nostr.build/89ad0e9a72ff60b6c8c7dc71bb92800598c56d09cad44a4ff6b700479104811f.jpg)`,
  //           position: "absolute",
  //           left: 0,
  //           top: 0,
  //           zIndex: 1,
  //           transform: "translate(-20%, -20%)",
  //         }}
  //       ></div>
  //       <div
  //         style={{
  //           width: "100%",
  //           display: "flex",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           gap: "20px",
  //           padding: "32px",
  //         }}
  //       >
  //         <div>
  //           <h1 style={{ fontSize: "144px", color: "black", height: "70px" }}>
  //             "
  //           </h1>

  //           <p
  //             style={{
  //               fontSize: "25px",
  //               color: "black",
  //             }}
  //           >
  //             Anarchy, today, is attack; it is war against every authority,
  //             every power, every state. In the future society, anarchy will be
  //             defence, the prevention of the re-establishment of any authority,
  //             any power, any state. -- Carlo
  //           </p>

  //           <div style={{ height: "8px" }}></div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "flex-end",
  //               alignContent: "flex-start",
  //               gap: " 24px",
  //             }}
  //           >
  //             <p style={{ color: "#aaaaaa", fontSize: "24px" }}>
  //               Shared by <span style={{ color: "black" }}>Walker</span>
  //             </p>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

  /* Trending ntoe */
  // return (
  //   <div
  //     style={{
  //       width: "800px",
  //       minHeight: "450px",
  //       backgroundColor: "white",
  //       borderTop: "14px solid #ee7700",
  //       padding: "3.5rem",
  //       display: "flex",
  //       justifyContent: "center",
  //       alignItems: "stretch",
  //       position: "relative"
  //     }}
  //   >
  //     <div
  //       style={{
  //         width: "100%",
  //         height: "100%",
  //         backgroundColor: "white",
  //         borderTop: "14px solid #ee7700",
  //         padding: "3.5rem",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "stretch",
  //         position: "absolute",
  //         left: 0,
  //         top: 0,
  //       }}
  //     >
  //       <div
  //         style={{
  //           width: "100%",
  //           height: "100%",
  //           display: "flex",
  //           justifyContent: "space-between",
  //           flexDirection: "column",
  //           rotate: "5deg",
  //           zIndex: 0,
  //           backgroundColor: "white",
  //           borderRadius: "20px",
  //           boxShadow: "0 4px 40px #aaaaaa55",
  //         }}
  //       ></div>
  //     </div>
  //     <div
  //       style={{
  //         width: "100%",
  //         display: "flex",
  //         justifyContent: "space-between",
  //         flexDirection: "column",
  //         position: "relative",
  //         zIndex: 2,
  //         backgroundColor: "white",
  //         borderRadius: "20px",
  //         boxShadow: "0 4px 40px #aaaaaa55",
  //       }}
  //     >
  //       <div style={{ width: "100%", position: "static" }}>
  //         <div
  //           style={{
  //             width: "100%",
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             gap: "20px",
  //             padding: "16px 16px 0",
  //           }}
  //         >
  //           <div
  //             style={{
  //               width: "100%",
  //               display: "flex",
  //               justifyContent: "space-between",
  //             }}
  //           >
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 alignItems: "center",
  //                 gap: "16px",
  //               }}
  //             >
  //               <div
  //                 style={{
  //                   minWidth: "50px",
  //                   minHeight: "50px",
  //                   borderRadius: "50%",
  //                   backgroundSize: "cover",
  //                   backgroundPosition: "center",
  //                   backgroundImage: `url(https://image.nostr.build/89ad0e9a72ff60b6c8c7dc71bb92800598c56d09cad44a4ff6b700479104811f.jpg)`,
  //                 }}
  //               ></div>
  //               <div>
  //                 <p style={{ color: "black" , fontSize: "16px"}}>Joan cornella</p>
  //                 <p style={{ color: "#aaaaaa" }}>@JoanCordn23</p>
  //               </div>
  //             </div>
  //             <h3 style={{padding: ".5rem"}}>📌</h3>
  //           </div>
  //         </div>
  //         <div style={{ padding: "16px" }}>
  //           <p style={{ color: "black", fontSize: "20px" }}>
  //             Lorem ipsum dolor sit amet consectetur, adipisicing elit. Illo,
  //             amet, tenetur repellat odit, praesentium blanditiis laudantium
  //             fuga perferendis sint vitae rerum natus iusto architecto quibusdam
  //             aut rem non. Rem, debitis!
  //           </p>
  //         </div>
  //       </div>
  //       <div style={{ padding: "16px", position: "static" }}>
  //         <p style={{ color: "#aaaaaa", fontSize: "16px" }}>
  //           Sep 12, 2025, 12:00PM
  //         </p>
  //       </div>
  //     </div>
  //   </div>
  // );

  /* Countdown */
  // return (
  //   <div
  //     style={{
  //       width: "800px",
  //       minHeight: "450px",
  //       backgroundColor: "#171718",
  //       padding: "3.5rem",
  //       display: "flex",
  //       justifyContent: "center",
  //       alignItems: "stretch",
  //       position: "relative",
  //     }}
  //   >
  //     <div
  //       style={{
  //         width: "100%",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         flexDirection: "column",
  //         position: "relative",
  //       }}
  //     >
  //       <div
  //         style={{
  //           width: "100%",
  //           display: "flex",
  //           justifyContent: "center",
  //         }}
  //       >
  //         <h2>Coming in</h2>
  //       </div>
  //       <div style={{ height: "30px" }}></div>
  //       <div
  //         style={{
  //           width: "100%",
  //           display: "flex",
  //           justifyContent: "center",

  //           gap: "16px",
  //           position: "relative",
  //         }}
  //       >
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             flexDirection: "column",
  //             position: "relative",
  //             gap: "16px",
  //           }}
  //         >
  //           <div style={{ position: "relative" }}>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 flexDirection: "column",
  //                 position: "relative",
  //                 padding: "2.5rem 4rem",
  //                 backgroundColor: "white",
  //                 borderRadius: "15px",
  //               }}
  //             ></div>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 flexDirection: "column",
  //                 position: "relative",
  //                 padding: "2.5rem 4rem",
  //                 backgroundColor: "white",
  //                 borderRadius: "15px",
  //               }}
  //             ></div>
  //             <h1
  //               style={{
  //                 color: "black",
  //                 position: "absolute",
  //                 left: "50%",
  //                 top: "50%",
  //                 transform: "translate(-50%, -50%)",
  //               }}
  //             >
  //               031
  //             </h1>
  //           </div>
  //           <p style={{ color: "#aaaaaa" }}>DAYS</p>
  //         </div>
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             flexDirection: "column",
  //             position: "relative",
  //             gap: "16px",
  //           }}
  //         >
  //           <div style={{ position: "relative" }}>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 flexDirection: "column",
  //                 position: "relative",
  //                 padding: "2.5rem 4rem",
  //                 backgroundColor: "white",
  //                 borderRadius: "15px",
  //               }}
  //             ></div>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 flexDirection: "column",
  //                 position: "relative",
  //                 padding: "2.5rem 4rem",
  //                 backgroundColor: "white",
  //                 borderRadius: "15px",
  //               }}
  //             ></div>
  //             <h1
  //               style={{
  //                 color: "black",
  //                 position: "absolute",
  //                 left: "50%",
  //                 top: "50%",
  //                 transform: "translate(-50%, -50%)",
  //               }}
  //             >
  //               15
  //             </h1>
  //           </div>
  //           <p style={{ color: "#aaaaaa" }}>HOURS</p>
  //         </div>
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             flexDirection: "column",
  //             position: "relative",
  //             gap: "16px",
  //           }}
  //         >
  //           <div style={{ position: "relative" }}>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 flexDirection: "column",
  //                 position: "relative",
  //                 padding: "2.5rem 4rem",
  //                 backgroundColor: "white",
  //                 borderRadius: "15px",
  //               }}
  //             ></div>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 flexDirection: "column",
  //                 position: "relative",
  //                 padding: "2.5rem 4rem",
  //                 backgroundColor: "white",
  //                 borderRadius: "15px",
  //               }}
  //             ></div>
  //             <h1
  //               style={{
  //                 color: "black",
  //                 position: "absolute",
  //                 left: "50%",
  //                 top: "50%",
  //                 transform: "translate(-50%, -50%)",
  //               }}
  //             >
  //               01
  //             </h1>
  //           </div>
  //           <p style={{ color: "#aaaaaa" }}>MINUTES</p>
  //         </div>
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             flexDirection: "column",
  //             position: "relative",
  //             gap: "16px",
  //           }}
  //         >
  //           <div style={{ position: "relative" }}>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 flexDirection: "column",
  //                 position: "relative",
  //                 padding: "2.5rem 4rem",
  //                 backgroundColor: "white",
  //                 borderRadius: "15px",
  //               }}
  //             ></div>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 flexDirection: "column",
  //                 position: "relative",
  //                 padding: "2.5rem 4rem",
  //                 backgroundColor: "white",
  //                 borderRadius: "15px",
  //               }}
  //             ></div>
  //             <h1
  //               style={{
  //                 color: "black",
  //                 position: "absolute",
  //                 left: "50%",
  //                 top: "50%",
  //                 transform: "translate(-50%, -50%)",
  //               }}
  //             >
  //               13
  //             </h1>
  //           </div>
  //           <p style={{ color: "#aaaaaa" }}>SECONDS</p>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

  /* Quiz */
  // return (
  //   <div
  //     style={{
  //       width: "800px",
  //       height: "550px",
  //       backgroundColor: "#171718",
  //       padding: "2.5rem 0",
  //       display: "flex",
  //       justifyContent: "center",
  //       alignItems: "center",
  //       overflow: "hidden",
  //       position: "relative",
  //       gap: "24px",
  //       background: "#171718",
  //     }}
  //   >
  //     <div
  //       style={{
  //         width: "80%",
  //         height: "70%",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         flexDirection: "column",
  //         position: "relative",
  //         borderRadius: "42px",
  //         padding: "4rem",
  //         backgroundColor: "#FCC121",
  //         flexShrink: 0,
  //       }}
  //     ></div>
  //     <div
  //       style={{
  //         width: "80%",
  //         height: "100%",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         flexDirection: "column",
  //         position: "relative",
  //         borderRadius: "42px",
  //         padding: "4rem",
  //         backgroundColor: "#DD3329",
  //         gap: "24px",
  //         flexShrink: 0,
  //       }}
  //     >
  //       <div
  //         style={{
  //           backgroundColor: "white",
  //           borderRadius: "32px",
  //           padding: ".5rem 1rem",
  //           color: "black",
  //         }}
  //       >
  //         Entertainment: Cartoon &amp; Animations
  //       </div>
  //       <h1
  //         style={{
  //           textAlign: "center",
  //           color: "white",
  //           lineHeight: "110%",
  //           fontSize: "48px",
  //         }}
  //       >
  //         Blue Danube was one of the musical pieces featured in Disney&#039;s
  //         1940&#039;s film Fantasia.
  //       </h1>
  //     </div>
  //     <div
  //       style={{
  //         width: "80%",
  //         height: "70%",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         flexDirection: "column",
  //         position: "relative",
  //         borderRadius: "42px",
  //         padding: "4rem",
  //         backgroundColor: "#416454",
  //         flexShrink: 0,
  //       }}
  //     ></div>
  //   </div>
  // );

  /* QR */
  // return (
  //   <div
  //     style={{
  //       width: "800px",
  //       minHeight: "800px",
  //       backgroundColor: "#171718",
  //     }}
  //   >
  //     <div
  //       style={{
  //         width: "100%",
  //         minHeight: "800px",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "flex-start",
  //         position: "relative",
  //         overflow: "hidden",
  //       }}
  //     >
  //       <div
  //         style={{
  //           width: "100%",
  //           minHeight: "800px",
  //           position: "relative",
  //           zIndex: 2,
  //           display: "flex",
  //           justifyContent: "center",
  //           flexDirection: "column",
  //           gap: "20px",
  //           alignItems: "center",
  //           padding: "32px",
  //         }}
  //       >
  //        <div
  //         style={{
  //           minWidth: "150px",
  //           minHeight: "150px",
  //           borderRadius: "50%",
  //           overflow: "hidden",
  //           backgroundSize: "cover",
  //           backgroundPosition: "center",
  //           backgroundImage: `url(https://image.nostr.build/89ad0e9a72ff60b6c8c7dc71bb92800598c56d09cad44a4ff6b700479104811f.jpg)`,
  //           outline: "10px solid white",
  //           transform: "translateY(30px)"
  //         }}
  //       ></div>

  //         <div
  //         style={{
  //           minWidth: "450px",
  //           minHeight: "450px",
  //           borderRadius: "40px",
  //           overflow: "hidden",
  //           backgroundSize: "cover",
  //           backgroundPosition: "center",
  //           backgroundImage: `url(https://as2.ftcdn.net/v2/jpg/05/31/42/91/1000_F_531429128_iD9CMrJY2YO2CLr3u8avUksuhg6LfGY4.jpg)`,
  //         }}
  //       ></div>
  //              <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             flexDirection: "column",
  //             gap: "16px"
  //           }}
  //         >
  //           <h2 style={{ fontSize: "58px" }}>Zap <span style={{color: "#ee7700"}}>1000</span> sats</h2>
  //           <p style={{color: "#999999", fontSize: "24px"}}>to email@email.com</p>
  //         </div>
  //         <div style={{height: "05px"}}></div>
  //       </div>
  //     </div>
  //   </div>
  // );

  /* Highest Zap */
  // return (
  //   <div
  //     style={{
  //       width: "800px",
  //       minHeight: "800px",
  //       backgroundColor: "#171718",
  //     }}
  //   >
  //     <div
  //       style={{
  //         width: "100%",
  //         minHeight: "800px",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "flex-start",
  //         position: "relative",
  //         overflow: "hidden",
  //       }}
  //     >
  //       <div
  //         style={{
  //           position: "absolute",
  //           left: "50%",
  //           top: "50%",
  //           transform: "translate(-50%, -50%)",
  //           width: "120%",
  //           height: "120%",
  //           filter: "blur(6px)",
  //           backgroundSize: "cover",
  //           overflow: "hidden",
  //           backgroundPosition: "center",
  //           backgroundImage: `url(https://image.nostr.build/29572d4118c1b1e92a27a853e741bd8c1505f981f94262fd96e2d6586d72f7aa.png)`,
  //           zIndex: 0,
  //         }}
  //       ></div>
  //       <div
  //         style={{
  //           position: "absolute",
  //           left: 0,
  //           top: 0,
  //           width: "100%",
  //           height: "100%",
  //           backgroundColor: "rgba(0,0,0,.8)",
  //           zIndex: 1,
  //         }}
  //       ></div>
  //       <div
  //         style={{
  //           width: "100%",
  //           minHeight: "800px",
  //           position: "relative",
  //           zIndex: 2,
  //           display: "flex",
  //           justifyContent: "center",
  //           flexDirection: "column",
  //           gap: "20px",
  //           alignItems: "center",
  //           padding: "32px",
  //         }}
  //       >
  //         <div
  //           style={{
  //             minWidth: "250px",
  //             minHeight: "250px",
  //             borderRadius: "50%",
  //             overflow: "hidden",
  //             backgroundSize: "cover",
  //             backgroundPosition: "center",
  //             backgroundImage: `url(https://image.nostr.build/89ad0e9a72ff60b6c8c7dc71bb92800598c56d09cad44a4ff6b700479104811f.jpg)`,
  //             outline: "10px solid #ee7700",
  //           }}
  //         ></div>
  //         <div style={{ height: "05px" }}></div>
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             flexDirection: "column",
  //             gap: "16px",
  //           }}
  //         >
  //           <p style={{ color: "#999999", fontSize: "24px" }}>Highest zapper</p>
  //           <h2 style={{ fontSize: "58px", textAlign: "center" }}>
  //             Mike Eizenhaut
  //           </h2>
  //           <h4 style={{ fontSize: "40px", textAlign: "center" }}>
  //             🏆 with <span style={{ color: "#ee7700" }}>1000</span> sats 🏆
  //           </h4>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

  /* Profile visiting */
  // return (
  //   <div
  //     style={{
  //       width: "800px",
  //      height: "550px",
  //       backgroundColor: "#171718",
  //       display: "flex",
  //       justifyContent: "center",
  //       alignItems: "center",
  //       overflow: "hidden",
  //       position: "relative",
  //       gap: "24px",
  //     }}
  //   >
  //     <div
  //       style={{
  //         width: "80%",
  //         height: "70%",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         flexDirection: "column",
  //         position: "relative",
  //         borderRadius: "32px",
  //         padding: "4rem",
  //         backgroundColor: "#FCC121",
  //         flexShrink: 0,
  //       }}
  //     ></div>
  //     <div
  //       style={{
  //         width: "85%",
  //         minHeight: "500px",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "flex-start",
  //         position: "relative",
  //         overflow: "hidden",
  //         flexShrink: 0,
  //       }}
  //     >
  //       <div
  //         style={{
  //           width: "100%",
  //           minHeight: "500px",
  //           position: "relative",
  //           zIndex: 2,
  //           display: "flex",
  //           justifyContent: "center",
  //           flexDirection: "column",
  //           gap: "20px",
  //           alignItems: "center",
  //           padding: "32px",
  //         }}
  //       >
  //         <div
  //           style={{
  //             width: "100%",
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             gap: "20px",
  //           }}
  //         >
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center",
  //               flexDirection: "column",
  //               gap: "20px",
  //               alignItems: "center",
  //               backgroundColor: "#343434",
  //               borderRadius: "20px",
  //               padding: "1.5rem",
  //             }}
  //           >
  //             <div
  //               style={{
  //                 minWidth: "100px",
  //                 minHeight: "100px",
  //                 borderRadius: "50%",
  //                 overflow: "hidden",
  //                 backgroundSize: "cover",
  //                 backgroundPosition: "center",
  //                 backgroundImage: `url(https://image.nostr.build/89ad0e9a72ff60b6c8c7dc71bb92800598c56d09cad44a4ff6b700479104811f.jpg)`,
  //               }}
  //             ></div>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 alignItems: "center",
  //                 flexDirection: "column",
  //               }}
  //             >
  //               <p
  //                 style={{
  //                   fontSize: "20px",
  //                   textAlign: "center",
  //                   color: "white",
  //                 }}
  //               >
  //                 Mike Eizenhaut
  //               </p>
  //               <p style={{ color: "#999999", fontSize: "16px" }}>
  //                 @mikee_alja
  //               </p>
  //             </div>
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center",
  //               flexDirection: "column",
  //               gap: "20px",
  //               alignItems: "center",
  //               backgroundColor: "#343434",
  //               borderRadius: "20px",
  //               padding: "1.5rem",
  //             }}
  //           >
  //             <div
  //               style={{
  //                 minWidth: "100px",
  //                 minHeight: "100px",
  //                 borderRadius: "50%",
  //                 overflow: "hidden",
  //                 backgroundSize: "cover",
  //                 backgroundPosition: "center",
  //                 backgroundImage: `url(https://image.nostr.build/89ad0e9a72ff60b6c8c7dc71bb92800598c56d09cad44a4ff6b700479104811f.jpg)`,
  //               }}
  //             ></div>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 alignItems: "center",
  //                 flexDirection: "column",
  //               }}
  //             >
  //               <p
  //                 style={{
  //                   fontSize: "20px",
  //                   textAlign: "center",
  //                   color: "white",
  //                 }}
  //               >
  //                 Mike Eizenhaut
  //               </p>
  //               <p style={{ color: "#999999", fontSize: "16px" }}>
  //                 @mikee_alja
  //               </p>
  //             </div>
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center",
  //               flexDirection: "column",
  //               gap: "20px",
  //               alignItems: "center",
  //               backgroundColor: "#343434",
  //               borderRadius: "20px",
  //               padding: "1.5rem",
  //             }}
  //           >
  //             <div
  //               style={{
  //                 minWidth: "100px",
  //                 minHeight: "100px",
  //                 borderRadius: "50%",
  //                 overflow: "hidden",
  //                 backgroundSize: "cover",
  //                 backgroundPosition: "center",
  //                 backgroundImage: `url(https://image.nostr.build/89ad0e9a72ff60b6c8c7dc71bb92800598c56d09cad44a4ff6b700479104811f.jpg)`,
  //               }}
  //             ></div>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 alignItems: "center",
  //                 flexDirection: "column",
  //               }}
  //             >
  //               <p
  //                 style={{
  //                   fontSize: "20px",
  //                   textAlign: "center",
  //                   color: "white",
  //                 }}
  //               >
  //                 Mike Eizenhaut
  //               </p>
  //               <p style={{ color: "#999999", fontSize: "16px" }}>
  //                 @mikee_alja
  //               </p>
  //             </div>
  //           </div>

  //         </div>
  //         <div
  //           style={{
  //             width: "100%",
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             gap: "20px",
  //           }}
  //         >
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center",
  //               flexDirection: "column",
  //               gap: "20px",
  //               alignItems: "center",
  //               backgroundColor: "#343434",
  //               borderRadius: "20px",
  //               padding: "1.5rem",
  //             }}
  //           >
  //             <div
  //               style={{
  //                 minWidth: "100px",
  //                 minHeight: "100px",
  //                 borderRadius: "50%",
  //                 overflow: "hidden",
  //                 backgroundSize: "cover",
  //                 backgroundPosition: "center",
  //                 backgroundImage: `url(https://image.nostr.build/89ad0e9a72ff60b6c8c7dc71bb92800598c56d09cad44a4ff6b700479104811f.jpg)`,
  //               }}
  //             ></div>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 alignItems: "center",
  //                 flexDirection: "column",
  //               }}
  //             >
  //               <p
  //                 style={{
  //                   fontSize: "20px",
  //                   textAlign: "center",
  //                   color: "white",
  //                 }}
  //               >
  //                 Mike Eizenhaut
  //               </p>
  //               <p style={{ color: "#999999", fontSize: "16px" }}>
  //                 @mikee_alja
  //               </p>
  //             </div>
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center",
  //               flexDirection: "column",
  //               gap: "20px",
  //               alignItems: "center",
  //               backgroundColor: "#343434",
  //               borderRadius: "20px",
  //               padding: "1.5rem",
  //             }}
  //           >
  //             <div
  //               style={{
  //                 minWidth: "100px",
  //                 minHeight: "100px",
  //                 borderRadius: "50%",
  //                 overflow: "hidden",
  //                 backgroundSize: "cover",
  //                 backgroundPosition: "center",
  //                 backgroundImage: `url(https://image.nostr.build/89ad0e9a72ff60b6c8c7dc71bb92800598c56d09cad44a4ff6b700479104811f.jpg)`,
  //               }}
  //             ></div>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 alignItems: "center",
  //                 flexDirection: "column",
  //               }}
  //             >
  //               <p
  //                 style={{
  //                   fontSize: "20px",
  //                   textAlign: "center",
  //                   color: "white",
  //                 }}
  //               >
  //                 Mike Eizenhaut
  //               </p>
  //               <p style={{ color: "#999999", fontSize: "16px" }}>
  //                 @mikee_alja
  //               </p>
  //             </div>
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center",
  //               flexDirection: "column",
  //               gap: "20px",
  //               alignItems: "center",
  //               backgroundColor: "#343434",
  //               borderRadius: "20px",
  //               padding: "1.5rem",
  //             }}
  //           >
  //             <div
  //               style={{
  //                 minWidth: "100px",
  //                 minHeight: "100px",
  //                 borderRadius: "50%",
  //                 overflow: "hidden",
  //                 backgroundSize: "cover",
  //                 backgroundPosition: "center",
  //                 backgroundImage: `url(https://image.nostr.build/89ad0e9a72ff60b6c8c7dc71bb92800598c56d09cad44a4ff6b700479104811f.jpg)`,
  //               }}
  //             ></div>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 alignItems: "center",
  //                 flexDirection: "column",
  //               }}
  //             >
  //               <p
  //                 style={{
  //                   fontSize: "20px",
  //                   textAlign: "center",
  //                   color: "white",
  //                 }}
  //               >
  //                 Mike Eizenhaut
  //               </p>
  //               <p style={{ color: "#999999", fontSize: "16px" }}>
  //                 @mikee_alja
  //               </p>
  //             </div>
  //           </div>

  //         </div>

  //       </div>
  //     </div>
  //     <div
  //       style={{
  //         width: "80%",
  //         height: "70%",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         flexDirection: "column",
  //         position: "relative",
  //         borderRadius: "32px",
  //         padding: "4rem",
  //         backgroundColor: "#FCC121",
  //         flexShrink: 0,
  //       }}
  //     ></div>
  //   </div>
  // );
}
